module.exports = __webpack_public_path__ + "img/1.cleaned_floor.f6cb0559.svg";